import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { connect } from 'react-redux';
import log from '../../../helpers/logger';
import { NavLink, withRouter } from 'react-router-dom';
import { pagesRoutes } from '../../../app/Router.js';
import { getDefaultPath } from '../../../helpers/utils'
import { login, logout, getCurrentUser } from '../../../redux/Auth';
import { cutHash } from '../../../helpers/formatter';
import {hideMobileSidebarVisibility} from '../../../redux/SideBar';

class SidebarContent extends PureComponent {

  constructor(props) {
    super(props);

    this.buildTree = this.buildTree.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  hideSidebar = () => {
    this.props.onClick();
  };

  hideMobileSidebarVisibility = () => {
    this.props.hideMobileSidebarVisibility();
    // this.props.onClick();
  };

  buildTree(menuList, parentid) {
    log.debug(menuList, window.location);
    return menuList.filter((obj) => (!parentid || obj.ParentId == parentid)).map((obj, i) => {
      if (obj.ParentId == parentid) {
        var dl = "";
        var childStr = this.buildTree(menuList, obj.MenuId);
        // Nikita active menu indication logic update
        var active = obj.reactPath === cutHash(window.location.hash);
        if (childStr.length > 0) {
          if (obj.ParentId === "") {
            return (<SidebarCategory key={i} title={obj.MenuText} icon='menu'> {childStr}</SidebarCategory>);
          } else {
            return (<SidebarCategory key={i} title={obj.MenuText}> {childStr}</SidebarCategory>);
          }
        } else {
          // Nikita active menu indication logic use
          dl = <SidebarLink key={i} title={obj.MenuText} active={active} route={obj.reactPath ? getDefaultPath(obj.reactPath) : null} />;
          return (dl);
        }
      }
    })
  }

  handleLogout(event) {
    this.props.logout();
    this.props.hideMobileSidebarVisibility();
  }

  render() {
    // const menuList = (this.props.menu || {}).menuList;
    // const myScreen = pagesRoutes.filter((v) => (v.inMenu)).reduce((a, o) => { a[o.screenId] = o; return a }, {});
    // const myMenu = (menuList || []).filter((m) => (myScreen[m.ScreenId])).map((m) => ({ ...m, reactPath: (myScreen[m.ScreenId] || {}).path }));
    // const myParents = (myMenu || {}).reduce((a, o) => {
    //   a[o.QId] = o;
    //   a[o.ParentQId] = o;
    //   a[o.ParentQId.split(".")[o.ParentQId.split(".").length - 2]] = o;
    //   a[o.ParentQId.split(".")[o.ParentQId.split(".").length - 3]] = o;
    //   return a
    // }, {});
    // const myFullList = (menuList || []).filter(m => myParents[m.QId]).map((m) => ({ ...m, reactPath: (myScreen[m.ScreenId] || {}).path }));

    // log.debug("fullList2", myFullList);

    const myFullList = this.props.myFullList;

    const menu = [
      {key: 1, title: 'Home', icon: 'home', route: '/dashboard', group: ['C','P','E']},
      {key: 2, title: 'Account Settings', icon: 'account-box', route: '/account-settings', group: ['C','P','E']},
      // {key: 3, title: 'Payment Method', icon: 'credit-card', route: '/payment-method', group: ['P','E']},
    ]

    return (
      <div className='sidebar__content'>
        <ul className='sidebar__block'>
          <div>
            {/* {
              myFullList.length > 0 ? this.buildTree(myFullList, '') : ''
            } */}
            { /* Nikita new menu items */}
            {menu.map((obj, i) => (
              <SidebarLink key={i} title={obj.title} active={obj.route === cutHash(window.location.hash)} icon={obj.icon} route={obj.route ? getDefaultPath(obj.route) : null} />
            ))}
            {/* <NavLink to='/dashboard' onClick={this.hideMobileSidebarVisibility}
              activeClassName='sidebar__link-active'>
              <li className='sidebar__link'>
                <span className={`sidebar__link-icon lnr lnr-home ${'/dashboard' === cutHash(window.location.hash) && 'sidebar__link-icon-active'}`} />
                <p className={`sidebar__link-title ${'/dashboard' === cutHash(window.location.hash) && 'sidebar__link-active'}`}>Home</p>
              </li>
            </NavLink> */}
            <li className='sidebar__link mb-20' onClick={this.handleLogout}>
              <span className='sidebar__link-icon mdi mdi-power' />
              <p className='sidebar__link-title'>{this.props.auth.Label.Logout}</p>
            </li>
            <NavLink to='/upgrade' onClick={this.hideMobileSidebarVisibility}
              activeClassName='sidebar__link-active'>
              <li className='sidebar__link mb-20 bg-rg-blue p-25'>
                <span className='sidebar__link-icon mdi mdi-trending-up color-white lh-4' />
                <p className='sidebar__link-title color-white t-18'>Upgrade Options</p>
              </li>
            </NavLink>
          </div>

          {/* <SidebarCategory title='First Level Item' icon='menu'>
            <SidebarLink title='Second Level Item' route="" />
            <SidebarLink title='Second Level Item' route=""/>
            <SidebarCategory title='Second Level Item'>
              <SidebarLink title='Third Level Item' />
              <SidebarLink title='Third Level Item' />
            </SidebarCategory>
          </SidebarCategory> */}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: (state.auth || {}).user,
  auth: state.auth,
  menu: (state.auth || {}).menu,
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    { login: login },
    { logout: logout },
    { getCurrentUser: getCurrentUser },
    { hideMobileSidebarVisibility: hideMobileSidebarVisibility },
  ), dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(SidebarContent);


// WEBPACK FOOTER //
// ./src/pages/_layout/sidebar/SidebarContent.js